import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from '@/App.vue'
import { i18n } from '@/app/i18n'
import { createAppQueryClient } from '@/app/queryClient'
import { createAppRouter } from '@/app/router'
import { installSessionHandlers } from '@/app/session'
import '@/app/styles/main.css'

const app = createApp(App)
const pinia = createPinia()
const router = createAppRouter()

app.use(pinia)
app.use(i18n)
app.use(router)
// The client is built in `app/queryClient.ts` so its defaults — including the dashboard and report
// staleness of audit P-02 — can be tested without mounting the app.
app.use(VueQueryPlugin, { queryClient: createAppQueryClient() })

// When the session is gone, or a temporary password must be replaced first, the app — not the
// HTTP client — decides where the user goes (`app/session.ts`).
installSessionHandlers(router, pinia)

document.documentElement.lang = i18n.global.locale.value

app.mount('#app')
